import React, { Component } from "react";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import close from "../../../img/close.svg"
import "./style.scss";

export class AnimationSequence extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getNext = () => {
    if (
      this.props.data.hasOwnProperty("pIndex") &&
      this.props.data.hasOwnProperty("tIndex")
    ) {

      if(this.props.taskPages[this.props.data.pIndex].tasks.length > (this.props.data.tIndex + 1)){
        this.props.setModal({
          display: true,
          type: this.props.taskPages[this.props.data.pIndex].tasks[this.props.data.tIndex + 1].modal.type,
          size: "lg",
          connect: -1,
          data: this.props.taskPages[this.props.data.pIndex].tasks[this.props.data.tIndex + 1].modal,
        });
      } else {
        this.props.setModal({
          display: true,
          type: this.props.taskPages[this.props.data.pIndex + 1].tasks[0].modal.type,
          size: "lg",
          connect: -1,
          data: this.props.taskPages[this.props.data.pIndex + 1].tasks[0].modal,
        });
      }
    }
  };

  finishStep = () => {
    switch (this.props.type) {
      case "ROTATE_CUVETTE":
        this.rotateCuvette();
        break;
      case "HOLD_CUVETTE":
        this.holdCuvette();
        break;
      case "OVERNIGHT_WAIT":
        this.wait24hours();
        break;
      case "DEPOSIT_SOLUTION":
        this.depositSolution();
        break;
      case "LOAD_GELBOX_SOLUTION":
        this.loadGelBoxSolution();
        this.getNext();
        break;
      case "PREPARE_GELBOX":
        this.prepareGelBox();
        this.getNext();
        break;
      case "RUN_GELBOX":
        this.runGelBox();
        this.getNext();
        break;
      case "VISUALISE_GEL":
        this.visualizeGel();
        this.getNext();
        break;
      case "PIPETTE_PLUNGER":
        this.pipettePlunger();
        break;
      case "PUT_ON_PPE":
        this.putOnPPE();
        break;
      case "THERMOCYCLER_RUN":
        this.runThermocycler();
        this.getNext();
        break;
      default:
      // code block
    }
  };

  getTitle = () => {
    let title;

    switch (this.props.type) {
      case "ROTATE_CUVETTE":
        title = "Orientate cuvette";
        break;
      case "HOLD_CUVETTE":
        title = "Hold and orient the cuvette";
        break;
      case "DEPOSIT_SOLUTION":
        title = "Pipetting samples";
        break;
      case "LOAD_GELBOX_SOLUTION":
        title = "Loading samples";
        break;
      case "PREPARE_GELBOX":
        title = "Preparing gel electrophoresis box";
        break;
      case "RUN_GELBOX":
        title = "Running samples";
        break;
      case "VISUALISE_GEL":
        title = "Visualizing gel";
        break;
      case "PIPETTE_PLUNGER":
        title = "Mixing sample";
        break;
      case "PUT_ON_PPE":
        title = "Putting on PPE";
        break;
      case "THERMOCYCLER_RUN":
        title = "Running the thermocycler";
        break;
      case "OVERNIGHT_WAIT":
        title = "Wait 12 hours";
        break;
      default:
      // code block
    }

    return title;
  };

  wait24hours = () => {
    //this.props.prepareGelBox(true);

    this.props.glassTubes.forEach((glassTube)=>{
      this.props.setGlassTubepH({
        id: glassTube.id,
        pH: 6.9
      })
      if(this.props.light[0].isOn){
        if(glassTube.plantId >= 0){
          if(glassTube.boxId >= 0){
            this.props.setGlassTubepH({
              id: glassTube.id,
              pH: 6
            })
          } else {
            this.props.setGlassTubepH({
              id: glassTube.id,
              pH: 8
            })
          }
        } 
      }
    })

    this.props.setRun12hours({
      run12hours: true
    })

    this.props.showModal({
      display: false,
    });
  };
  depositSolution = () => {
    let rowMap = {
      "Control 1 (normal GENE X, positive control)": "Control 1 Thermocycler",
      "Control 2 (mutated GENE X, positive control)": "Control 2 Thermocycler",
      "Control 3 (no template, negative control)": "Control 3 Thermocycler",
      "Control 4 (prokaryotic control DNA, negative control)":
        "Control 4 Thermocycler",
      "Control 1 (Positive Control)": "Control 1 Thermocycler",
      "Control 2 (Positive Control)": "Control 2 Thermocycler",
      "Control 3 (Negative Control)": "Control 3 Thermocycler",
      "Control 4 (DNA Negative Control)": "Control 4 Thermocycler",
    };

    let solMap = {
      "1 μl extracted human DNA": "Extracted Human DNA",
      "1 μl normal GENE X control DNA": "Normal GENE X Control DNA",
      "1 µL mutated GENE X control DNA": "Shorter GENE X Control DNA",
      "1 μl DNase free water": "DNase Free Water",
      "1 μl prokaryotic control DNA": "Prokaryotic Control DNA",
    };

    this.props.tableData.data.forEach((row, rowIndex) => {
      if (rowIndex !== 0) {
        let itemProps = this.props.solutions.find(
          (solution) => solution.type === rowMap[row[0]]
        );
        let solutions = [];

        // Set the template DNA based off the Protocol Table
        if (row[1] !== null) {
          solutions.push({
            [solMap[row[1]]]: 1,
          });
        }

        // Set the Master Mix volume
        if (row[2] !== null) {
          let solutionsArr = Object.keys(this.props.solutions[6].solutions);
          let totalVol = this.props.solutions[6].volume;

          // Master Mix is ID 7
          solutionsArr.forEach((solution, index) => {
            let solutionVolume = this.props.solutions[6].solutions[solution];

            solutions.push({
              [solution]: row[2] * (solutionVolume / totalVol),
            });
          });
        }

        // Set the dH20 volume
        // if(row[4] !== null){
        //   solutions.push({
        //     "DNase Free Water": parseFloat(row[4], 10)
        //   })
        // }

        if (
          typeof itemProps !== "undefined" &&
          Object.keys(solutions).length > 0
        ) {
          this.props.incSolution({
            id: itemProps.id,
            solutions: solutions,
            fragments: {},
          });
        }
      }
    });

    // this.props.decSolution({
    //   id: solutionID,
    //   type: solutionObj.type,
    //   amount: volume
    // });

    this.props.showModal({
      display: false,
    });
  };
  loadGelBoxSolution = () => {
    this.props.loadDNALadder(true);
    this.props.showModal({
      display: false,
    });
  };
  prepareGelBox = () => {
    this.props.prepareGelBox(true);
    this.props.showModal({
      display: false,
    });
  };
  runGelBox = () => {
    this.props.runGel(true);
    this.props.showModal({
      display: false,
    });
  };
  rotateCuvette = () => {
    this.props.rotateCuvette(true);
    this.props.showModal({
      display: false,
    });
  };
  holdCuvette = () => {
    this.props.holdCuvette(true);
    this.props.showModal({
      display: false,
    });
  };
  visualizeGel = () => {
    this.props.visualizeGel(true);
    this.props.showModal({
      display: false,
    });
  };
  pipettePlunger = () => {
    this.props.setSolutionMixed({
      id: this.props.id,
      mixed: true,
    });
    this.props.showModal({
      display: false,
    });
  };
  putOnPPE = () => {
    this.props.putOnPPE(true);
    this.props.showModal({
      display: false,
    });
  };
  runThermocycler = () => {
    this.props.runThermocycler(true);
    this.props.showModal({
      display: false,
    });
  };

  render() {
    return (
      <>
      <div
        aria-label="Close Button"
        tabIndex={0}
        className={
          this.props.type === "UNDO" &&
          this.props.size === "sm"
            ? "close-sm"
            : "close"
        }

        onKeyDown={e => {
          if (e.keyCode === 13 || e.keyCode === 32) this.finishStep(e);
        }}
        onClick={() => this.finishStep()}
      >
        <p>
          Close{" "}
          <img
            style={{
              display: "inline-block",
              top: "3px",
              position: "relative"
            }}
            src={close}
            aria-label="Close button"
          />
        </p>
      </div>
      <div
        className="modal-section deposit-solution"
        style={{
          width: "calc(100% - 0px)",
          //height: "650px",
          margin: "auto",
        }}
      >
        <div className="modal-header">
          <h2>{this.getTitle()}</h2>
        </div>

        <div className="modal-body">
          <div className="modal-inner" aria-label={this.props.altText}>
            <Player
              //alt='content-item'
              //className={props.className}
              // onEvent={event => {
              //   if (event === 'complete') this.finishStep();
              // }}
              autoplay
              controls
              src={this.props.animation}
            >
              <Controls visible={true} buttons={["play", "stop", "repeat"]} />
            </Player>
          </div>
        </div>

        <div className="modal-footer">
          <div
            style={{
              justifySelf: "flex-start",
              marginRight: "auto",
            }}
          >
            <p>
              Hit the "{(this.props.data.hasOwnProperty("pIndex") &&
                this.props.data.hasOwnProperty("tIndex")) ? "Next" : "Finish"} step"
              button when you want to move on.
            </p>
          </div>
          <button
            aria-label="Done"
            tabIndex={this.props.tab}
            className="modal-btn-primary"
            onClick={() => this.finishStep()}
          >
            {(this.props.data.hasOwnProperty("pIndex") &&
              this.props.data.hasOwnProperty("tIndex")) ? "Next" : "Finish"} step
          </button>
        </div>
      </div>
      </>
    );
  }
}
